import React, { FC } from 'react';
import classnames from 'classnames';
import { DateTime } from 'luxon';

import { PolicyDocumentType } from '@clearcover/core-app-types';
import { Asset, Spinner } from 'Shared/components';

import styles from '../style.module.css';
import { useDocumentsContext } from 'Policies/utils';

export const DocumentList: FC<{}> = () => {
  const { downloadDocument, downloadingDocuments, documents, loading, error } =
    useDocumentsContext();

  if (error) return null;

  return (
    <ul className={styles.documents} data-testid="documents">
      {!loading
        ? documents.map((doc, index) => (
            <li
              key={doc.id}
              onClick={downloadDocument.downloadPolicyDocument(doc)}
              title={`Download ${doc.name} - ${DateTime.fromISO(
                doc.createdAt
              ).toFormat('MM/dd/yy t')}`}
              className={classnames(styles.document, {
                [styles.disabled]: disableDownload(doc),
              })}
              data-testid={`policy-document-${index}`}
            >
              <Asset variant={'pdf'} />
              <div className={styles.title}>{doc.name}</div>
              <div className={styles.date}>{getDocInfo(doc)}</div>
              {downloadingDocuments.hasOwnProperty(doc.id) ? (
                <Spinner
                  type="blue"
                  variant="small"
                  id={`document-download-${index}`}
                />
              ) : (
                !disableDownload(doc) && <Asset variant={'download'} />
              )}
            </li>
          ))
        : Array(10)
            .fill('')
            .map((_, key) => (
              <li
                key={key}
                className={styles.loading}
                data-testid={'documents-loading'}
              >
                <Asset variant={'pdf'} />
                <div className={styles.title}>Document Name</div>
                <div className={styles.date}>
                  Created on 11/01/16 1:32 AM CST
                </div>
              </li>
            ))}
    </ul>
  );
};

function disableDownload(document: PolicyDocumentType): boolean {
  return document.type === 'signable_doc' && !document.signedAssetId;
}

function getDocInfo(document: PolicyDocumentType): string {
  if (document.type === 'signable_doc') {
    if (document.completedAt)
      return getDocInfoText('Signed on', document.completedAt);
    else if (document.viewedAt)
      return getDocInfoText('Viewed on', document.viewedAt);
    else if (document.createdAt)
      return getDocInfoText('Created on', document.createdAt);
    else return '';
  } else {
    return getDocInfoText('Created on', document.createdAt);
  }
}

function getDocInfoText(description: string, date: string): string {
  return `${description} ${DateTime.fromISO(date).toFormat('MM/dd/yy t')} ${
    DateTime.local().offsetNameShort
  }`;
}
